var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHangFinger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9ZM9.1875 13.875C9.70527 13.875 10.125 13.4553 10.125 12.9375C10.125 12.4197 9.70527 12 9.1875 12C8.66973 12 8.25 12.4197 8.25 12.9375C8.25 13.4553 8.66973 13.875 9.1875 13.875ZM9.1875 3.75C8.66973 3.75 8.25 4.16973 8.25 4.6875V10.3125C8.25 10.8303 8.66973 11.25 9.1875 11.25C9.70527 11.25 10.125 10.8303 10.125 10.3125V4.6875C10.125 4.16973 9.70527 3.75 9.1875 3.75Z",
    fill: "#1477EC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHangFinger);
export default __webpack_public_path__ + "static/media/hang_finger.320a9820236f63d97830c18a44f6b6df.svg";
export { ForwardRef as ReactComponent };